import { DateField } from '@/global/components/DateField'
import dayjs from 'dayjs'

interface DatePickerSingleProps {
    value?: Date | string | null
    onChange?: (value: Date | null) => void
    label?: string
    disabled?: boolean
}

/** Campo de data única para call-sites que falam `Date`, não `Dayjs`. */
export function DatePickerSingle({
    value,
    onChange,
    label,
    disabled = false,
}: DatePickerSingleProps) {
    return (
        <DateField
            label={label}
            disabled={disabled}
            value={value ? dayjs(value) : null}
            onChange={data => onChange?.(data?.toDate() ?? null)}
        />
    )
}
